import React from 'react';
import PropTypes from 'prop-types';
import componentBase from '../../../../src/lib/component-base';

const airportSearchLandingPageMobileImage = require('../../../../static/images/Airport-Conditions-Mobile-Background.jpg');
const fourOhFourBackground = require('../../../../static/images/SadBaggageClaim.jpg');
const subscriptionSignUpImage = require('../../../../static/images/SubscriptionSignUp-Background.jpg');
const newLoginBackground = require('../../../../static/images/LoginPageWallpaper.jpg');
const otpBackground = require('../../../../static/images/OTP-Background.jpg');

// On cloudfront
const accountDefaultBackground = '//assets.flightstats.com/v2/beta-login-2880.jpg';
const accountSettingsBackground = '//assets.flightstats.com/v2/Account-Settings-Background.jpg';
const airportConditionsWeatherBackground = '//assets.flightstats.com/v2/Airport-Conditions-Weather-Background.jpg';
const airportSearchLandingPageImage = '//assets.flightstats.com/v2/Airport-Conditions-Background.jpg';
const airportSearchLandingPageVideoWebm = '//assets.flightstats.com/v2/Airport-Conditions-Background.webm';
const airportSearchLandingPageVideoMP4 = '//assets.flightstats.com/v2/Airport-Conditions-Background.mp4';
const arrivalsDeparturesBackground = '//assets.flightstats.com/v2/Blue-Radar.jpg';
const dataExportsHomeImage = '//assets.flightstats.com/v2/Data-Exports-Wallpaper.jpg';
const delayMapsBackground = '//assets.flightstats.com/v2/Airport-Delay-Background.jpg';
const depArrLandingPageImage = '//assets.flightstats.com/v2/deparr-video-cover.jpg';
const depArrLandingPageVideoWebM = '//assets.flightstats.com/v2/deparr-video.webm';
const depArrLandingPageVideoMP4 = '//assets.flightstats.com/v2/deparr-video.mp4';
const flightSearchLandingPageImage = '//assets.flightstats.com/v2/flighttracker-video-cover.jpg';
const flightSearchLandingPageVideoWebM = '//assets.flightstats.com/v2/flighttracker-video.webm';
const flightSearchLandingPageVideoMP4 = '//assets.flightstats.com/v2/flighttracker-video.mp4';
const historicalSearchLandingPageImage = '//assets.flightstats.com/v2/Historical-Flights-Background.jpg';
const historicalSearchLandingPageVideoWebm = '//assets.flightstats.com/v2/Historical-Flights-Background.webm';
const historicalSearchLandingPageVideoMP4 = '//assets.flightstats.com/v2/Historical-Flights-Background.mp4';
const multiFlightSearchResultsImage = '//assets.flightstats.com/v2/Flight-Tracker-Multi-Flight-Background.jpg';
const homepageBackground = '//assets.flightstats.com/v2/Clouds-Background.jpg';

const imageLoaded = imgRef => (imgRef && imgRef.complete);

@componentBase('PageBackground')
class PageBackground extends React.Component {
  static propTypes = {
    mediaBreakpoint: PropTypes.object,
    componentName: PropTypes.string,
  };

  constructor(props, context) {
    super(props, context);
    this.state = { imageStatus: 'loading' };

    this.muiDefaultProps = {
      imageStyle: {
        position: 'fixed',
        marginTop: 'auto',
        marginLeft: 'auto',
        minWidth: '100%',
        minHeight: '100%',
        width: 'auto',
        height: 'auto',
        zIndex: -100,
        backgroundSize: 'cover',
      },
      videoStyle: {
        position: 'fixed',
        marginTop: 'auto',
        marginLeft: 'auto',
        minWidth: '100%',
        minHeight: '100%',
        width: 'auto',
        height: 'auto',
        zIndex: -100,
        backgroundSize: 'cover',
      },
    };
    this.handleImageErrored = this.handleImageErrored.bind(this);
    this.handleImageLoaded = this.handleImageLoaded.bind(this);
    this.checkIfBackgroundImageLoaded = this.checkIfBackgroundImageLoaded.bind(this);
    this.img = null;
  }

  componentDidMount() {
    if (!this.imageLoadInterval) {
      this.imageLoadInterval = setInterval(this.checkIfBackgroundImageLoaded, 200);
    }
  }

  componentWillUnmount() {
    clearInterval(this.imageLoadInterval);
    this.imageLoadInterval = null;
  }

  handleImageLoaded() {
    this.setState({ imageStatus: 'loaded' });
  }

  handleImageErrored() {
    this.setState({ imageStatus: 'failed' });
  }

  checkIfBackgroundImageLoaded() {
    let clear = false;
    if (!this.img) {
      clear = true;
    } else if (this.state.imageStatus !== 'loading') {
      clear = true;
    } else if (imageLoaded(this.img)) {
      clear = true;
      this.setState({ imageStatus: 'loaded' });
    }

    if (clear) {
      clearInterval(this.imageLoadInterval);
      this.imageLoadInterval = null;
    }
  }

  render() {
    let backgroundImage = arrivalsDeparturesBackground;
    let showVideo = false;
    let mp4Video = null;
    let webmVideo = null;
    let componentClass = null;
    let videoStyle = this.muiDefaultProps.videoStyle;
    let imageStyle = this.muiDefaultProps.imageStyle;

    const { componentName } = this.props;
    if (componentName) {
      switch (componentName) {
        case 'AccountProfile':
        case 'PaymentInformation':
          backgroundImage = accountSettingsBackground;
          break;
        case 'FourOhFour':
          backgroundImage = fourOhFourBackground;
          break;
        case 'MultiFlight':
          backgroundImage = multiFlightSearchResultsImage;
          break;
        case 'Subscribe':
        case 'SubscriptionSuccess':
          backgroundImage = subscriptionSignUpImage;
          break;
        case 'ViewPaymentHistoryDetail':
          backgroundImage = arrivalsDeparturesBackground;
          break;
        case 'AirportCurrentConditions':
          backgroundImage = airportConditionsWeatherBackground;
          break;
        case 'AirportDelayMap':
          backgroundImage = delayMapsBackground;
          break;
        case 'AirportSearch':
          showVideo = true;
          mp4Video = airportSearchLandingPageVideoMP4;
          webmVideo = airportSearchLandingPageVideoWebm;
          backgroundImage = airportSearchLandingPageImage;
          imageStyle = { right: '0', ...this.muiDefaultProps.imageStyle };
          videoStyle = { right: 0, ...this.muiDefaultProps.videoStyle };

          if (this.props.mediaBreakpoint && this.props.mediaBreakpoint.value <= 700) {
            backgroundImage = airportSearchLandingPageMobileImage;
            imageStyle = { ...imageStyle, right: null, height: '100% !important' };
          }
          break;
        case 'DeparturesArrivalsLanding':
          showVideo = true;
          mp4Video = depArrLandingPageVideoMP4;
          webmVideo = depArrLandingPageVideoWebM;
          backgroundImage = depArrLandingPageImage;
          break;
        case 'HistoricalSearch':
          showVideo = true;
          mp4Video = historicalSearchLandingPageVideoMP4;
          webmVideo = historicalSearchLandingPageVideoWebm;
          backgroundImage = historicalSearchLandingPageImage;
          break;
        case 'UnifiedSearch':
        case 'AdvancedSearch':
          showVideo = true;
          mp4Video = flightSearchLandingPageVideoMP4;
          webmVideo = flightSearchLandingPageVideoWebM;
          backgroundImage = flightSearchLandingPageImage;
          break;
        case 'Login':
          showVideo = false;
          backgroundImage = newLoginBackground;
          imageStyle = { ...this.muiDefaultProps.imageStyle, zIndex: -1 };
          break;
        case 'OnTimePerformance':
          showVideo = false;
          backgroundImage = otpBackground;
          break;
        case 'DataExports':
        case 'NewDataExports':
        case 'ExportsSearch':
          showVideo = false;
          backgroundImage = dataExportsHomeImage;
          break;
        case 'ForgotPassword':
        case 'VerifyEmail':
        case 'SignUp':
        case 'SignUpPreferences':
        case 'SubscriptionOverview':
          showVideo = false;
          backgroundImage = accountDefaultBackground;
          componentClass = 'account-image background-media';
          imageStyle = {
            position: 'fixed',
            marginTop: 'auto',
            marginLeft: 'auto',
            width: 'auto',
            height: 'auto',
            zIndex: -100,
            backgroundSize: 'cover',
          };
          break;
        case 'Homepage':
          backgroundImage = homepageBackground;
          break;
        case 'SubscriptionMarketing':
        default:
          // already set to arrivalsDeparturesBackground, do nothing
          showVideo = false;
          break;
      }

      if (__CLIENT__ &&
          showVideo &&
          this.props.mediaBreakpoint &&
          this.props.mediaBreakpoint.value > 500 &&
          (this.state.imageStatus === 'loaded' || this.state.imageStatus === 'failed')) {
        showVideo = true;
      } else {
        showVideo = false;
      }
    }

    const image = (
      <img
        ref={ref => (this.img = ref)}
        alt='background'
        key={`img-${backgroundImage}`}
        className={componentClass}
        style={imageStyle}
        src={backgroundImage}
        onLoad={__CLIENT__ ? this.handleImageLoaded : null}
        onError={this.handleImageErrored}
        id='fullscreen-background'
      />
    );

    let video = null;
    if (showVideo) {
      video = (
        <video
          key={`video-${backgroundImage}`}
          className='bg-video background-media'
          style={videoStyle}
          autoPlay
          loop='loop'
        >
          <source src={mp4Video} type='video/mp4' />
          <source src={webmVideo} type='video/webm' />
          <img src={backgroundImage} alt='Background' />
        </video>
      );
    }

    return (
      <div className='media-holder'>
        {image}
        {video}
      </div>
    );
  }
}

export default PageBackground;



// WEBPACK FOOTER //
// ./modules/App/components/children/PageBackground.js